import type {AppRouterContext} from "@project/router";

import {AppErrorBoundary, AppPendingBar} from "@project/layouts";
// Side-effect import: augments StaticDataRouteOption with `meta?: AppRouteMeta` globally.
import "@project/router";
import {Outlet, createRootRouteWithContext} from "@tanstack/react-router";

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: RootComponent,
  errorComponent: AppErrorBoundary,
});

function RootComponent() {
  return (
    <>
      <AppPendingBar />
      <Outlet />
    </>
  );
}
